import axios from 'axios';
import { AxiosInterceptor } from './axios.interceptor';

export class AxiosAdapter {
	constructor(config) {
		this.config = config;
	}

	async request() {
		try {
			console.log('try adapter');
			const response = await axios(this.config);
			return await new AxiosInterceptor(response).pipe();
		} catch (e) {
			console.log('catch adapter', e);
			throw e.response.data;
		}
	}
}
